export default class messageOrder {
  _Vue;
  _messageOrderEvent;
  _defaultNotificationTime;
  _orderData;
  _page;
  _limit;
  _isNoMore
  constructor(Vue, Router) {
    this._Vue = Vue;
    this._Router = Router;
    this._messageOrderEvent = null;
    this._defaultNotificationTime = 3000;
    this._orderData = {
      list: [],
      unread_count: 0,
    };
    this._page = 1;
    this._limit = 50;
    this._start();
  }

  _start = async () => {
    this._orderData = {
      list: [],
      unread_count: 0,
    };
    this._page = 1;
    this._limit = 50;
    setTimeout(()=> {
      if (!localStorage.getItem("userInfo")) {
        return;
      }
      this._getOrderList({ page: this._page, limit: this._limit });
    }, 1000)
  };

  _getMessageOrder = (list) => {
    this._remove();
    this._messageOrderEvent = setInterval(() => {
      if (!localStorage.getItem("userInfo")) {
        this._remove();
        return;
      }
      if (list.length > 0) {
        this._getNewOrder(list[0].id);
      } else {
        this._getNewOrder(0);
      }
    }, this._defaultNotificationTime);
  };

  _getNewOrder = (id) => {
    this._Vue.prototype
      .$ajax("Admin/Notify/getIncList", { id }, { method: "GET", load: false })
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          if (res.data.list.length > 0) {
            this._getMessageOrder(res.data.list);
            this._orderData.list.unshift(...res.data.list);
            this._orderData.unread_count =
              this._orderData.unread_count * 1 + res.data.list.length;
            console.log(this._orderData)
            this._Vue.prototype.$eventBus.$emit(
              "onMessageOrderList",
              this._orderData
            );
            // this._page = 1;
            // this._getOrderList({ page: this._page, limit: this._limit })
            this._Vue.prototype.$eventBus.$emit(
              "onNewMessageOrder",
              res.data.list
            );
          }
          if(res.data.sy_login == 0){
            const userInfo = JSON.parse(localStorage.getItem('userInfo') || {})
            localStorage.removeItem(`product-export-props-${userInfo.name}`)
            localStorage.removeItem('userInfo');
            this._Router.replace({
                path: '/login',
            })
          }
        } else {
          this._Vue.prototype.$message.error(res.data.message);
        }
      });
  };

  _getOrderList = async (params = {}) => {
    let {page, limit, reload} = params
    this._remove();
    if(reload) {
      this._orderData = {
        list: [],
        unread_count: 0
      };
    }
    await this._Vue.prototype
      .$ajax("Admin/Notify/getList", {page, limit}, { method: "GET", load: false })
      .then((res) => {
        if (res.status === 200) {
          if(res.data.list.length === 0) {
            this._isNoMore = true
          } else {
            this._isNoMore = false
          }
          // console.log(this._orderData.list.concat(res.data.list))
          this._orderData.list = this._orderData.list.concat(res.data.list);
          this._orderData.unread_count = res.data.unread_count;
          this._Vue.prototype.$eventBus.$emit(
            "onMessageOrderList",
            this._orderData
          );
        }
      });
    this._getMessageOrder(this._orderData.list);
  };

  _remove() {
    clearInterval(this._messageOrderEvent);
  }
}



// WEBPACK FOOTER //
// ./src/plugins/message/order.js